import { useEffect, useState, memo } from "react";
import { Box, Skeleton, Typography } from "@mui/material";

import { request } from "@/Api";
import { formattedCurrency } from "@/utils";
import {
    WidgetHeaderRow,
    ListRowDivider,
    ListRowItem,
    SeeAllRow,
} from "../primitives";

const DashboardClients = memo(() => {
    const [clients, setClients] = useState(null);

    useEffect(() => {
        request
            .get("/clients/mine")
            .then((r) => setClients(r.data || []))
            .catch(() => setClients([]));
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                height: "100%",
            }}
        >
            <WidgetHeaderRow
                title="Your Clients"
                count={clients?.length ?? null}
            />

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    flex: 1,
                    overflow: "auto",
                }}
            >
                {!clients &&
                    [1, 2, 3, 4].map((i) => (
                        <Skeleton
                            key={i}
                            variant="rounded"
                            height={44}
                            sx={{
                                borderRadius: "6px",
                                bgcolor: "action.hover",
                            }}
                        />
                    ))}
                {clients?.map((client, i) => (
                    <Box
                        key={client.id || i}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                        }}
                    >
                        {i > 0 && <ListRowDivider />}
                        <ListRowItem
                            href={`/clients/${client.id}`}
                            primary={client.name}
                            sub1={`${client.projects_count} project${client.projects_count !== 1 ? "s" : ""}`}
                            sub2={`${formattedCurrency(client.lifetime_revenue, client.currency)} lifetime`}
                        />
                    </Box>
                ))}
                {clients?.length === 0 && (
                    <Typography
                        sx={{
                            fontSize: 12,
                            color: "text.secondary",
                            fontFamily: "Inter Tight, sans-serif",
                            px: "8px",
                        }}
                    >
                        No clients assigned to you
                    </Typography>
                )}
            </Box>

            <SeeAllRow href="/clients" label="All clients" />
        </Box>
    );
});

DashboardClients.displayName = "DashboardClients";

export default DashboardClients;
